import {get, post} from '../Axios/Axios';


export function reportError(){
    return {
      status: false,
      message: "Something went wrong"
    }
  }

export function domainList( callback){

    get("/public/fetch-sso-domain").then((res)=>{

        if(res){
            
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

export function getZoneList( callback){

    get("/citizen/fetch-sso-zone").then((res)=>{

        if(res){
            
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}



export function deptBydomain( domainName,callback){

    get("/public/fetch-sso-department/"+domainName ).then((res)=>{

        if(res){
            
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

// export function ssoRoleBydomain( domainName,callback){

//     get("/public/fetch-sso-roles/"+domainName ).then((res)=>{

//         if(res){
            
//             callback(res);
//         }
//         else{
//             callback(reportError());
//         }
//     })

// }

export function ssoRoleBydomain( domainName,callback){

    let req={
        "domainCode":domainName
    }
    post("/public/sso-roles" ,req,0).then((res)=>{

        if(res){
            
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

export function ssoRoleBydept( domainName,callback){

    get("/public/fetch-sso-roles-dept/"+domainName ).then((res)=>{

        if(res){
            
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}
export function desigByDomain( domainName,callback){

    get("/public/fetch-sso-designation/"+domainName ).then((res)=>{

        if(res){
            
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}
export function desigByDept( domainName,callback){

    get("/public/fetch-sso-designation/"+domainName ).then((res)=>{

        if(res){
            
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}


// export function citizenDashboardDetails( callback){

    

//     get("/citizen/active").then((res)=>{

//         if(res){
//             console.log("Questions=",res)
//             callback(res);
//         }
//         else{
//             callback(reportError());
//         }
//     })

// }


export function citizenDashboardDetails(callback){

    post("/public/dept-applications",0,1).then((res)=>{

        if(res){
           
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

export function citizenSchemeDetails(mobNo,callback){

    let req={
        "mobile":mobNo
    }

    post("/citizen/fetch-conversation-data",req,1).then((res)=>{

        if(res){
           
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

export function pincodeList(callback){

    post("/public/pincode",0,0).then((res)=>{

        if(res){
        
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

export function localityList( loc,callback){

//    let loc=110095;
   let req={"pincode":loc};

    post("/public/locality1",req,0).then((res)=>{

        if(res){
    
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}
export function districtList(loc,callback){

    // let loc=110094;

    let req={"pincode":loc};
 
     post("/public/district1",req,0).then((res)=>{
 
         if(res){
          
             callback(res);
         }
         else{
             callback(reportError());
         }
     })
 
 }


 export function updateCitizenProfile(req, callback){

   

    post("/public/sso-user-update",req,0).then((res)=>{

        if(res){
     
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}


  export function registerNewUser(req, callback){

   

    post("/public/sso-user-create",req,0).then((res)=>{

        if(res){
     
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}


export function resetCitizenPassword(req, callback){

    // let mob={
    //     "input":mobNo
    // }

    post("/public/forgot-password",req,0).then((res)=>{

        if(res){
           
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}



export function sendOtpMobile(mobNo, callback){

    let mob={
        "input":mobNo
    }

    post("/public/fetch-send-otp",mob,0).then((res)=>{

        if(res){
           
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

export function verifyMobileOtp(mobNo,otp, callback){

    let otpReq={
        "mobileNumber":mobNo,
        "otp": otp
    }

    post("/public/verify-otp",otpReq,0).then((res)=>{

        if(res){
  
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}

// export function verifyMobileOtp(mobNo,otp, callback){

//     let otpReq={
//         "mobileNumber":mobNo,
//         "otp": otp
//     }

//     get("/public/verify-otp/"+otpReq).then((res)=>{

//         if(res){
//             console.log("Questions=",res)
//             callback(res);
//         }
//         else{
//             callback(reportError());
//         }
//     })

// }